import "./Navbar.css";
import { useTheme } from "../contexts/ThemeContext";
import { Link } from "react-router-dom";

interface User {
  id: string;
  username: string;
  discriminator: string;
  avatar: string | null;
  isAdmin?: boolean;
}

interface NavbarProps {
  user: User;
}

function Navbar({ user }: NavbarProps) {
  const { isDarkMode, toggleTheme } = useTheme();

  const getUserAvatar = () => {
    if (user.avatar) {
      return `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`;
    }
    return null;
  };

  return (
    <nav className="navbar">
      <div className="user-info">
        {getUserAvatar() ? (
          <img className="user-avatar" src={getUserAvatar()!} alt="Avatar" />
        ) : (
          <div className="user-avatar" style={{ background: "#7289DA" }}></div>
        )}
        <span>
          {user.username}#{user.discriminator}
        </span>
      </div>
      <div className="navbar-actions">
        {user.isAdmin && (
          <>
            <Link to="/admin" className="admin-link">
              Admin Panel
            </Link>
            <Link to="/dashboard" className="admin-link">
              Dashboard
            </Link>
          </>
        )}
        <button
          className="theme-toggle"
          onClick={toggleTheme}
          title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
          {isDarkMode ? "☀️" : "🌙"}
        </button>
        <a href="/auth/logout" className="logout-btn">
          Logout
        </a>
      </div>
    </nav>
  );
}

export default Navbar;
